import React, { forwardRef } from 'react'
import { withStyles, fade } from '@material-ui/core/styles'
import { 
    InputBase,
} from '@material-ui/core';

import './BootstrapInput.scss'

const TextInput = withStyles((theme) => ({
    // root: {
    //     'label + &': {
    //         marginTop: theme.spacing(10),
    //     },
    // },
    input: {
        position: 'relative',
        backgroundColor: theme.palette.common.white,
        border: `1px solid ${theme.palette.primary.grey}`,
        fontSize: 14,
        width: '380px',
        height: '32px',
        padding: '10px 12px',
        boxSizing: 'border-box',
        transition: theme.transitions.create(['border-color', 'box-shadow']),
        '&:focus': {
            boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 0.2rem`,
            borderColor: theme.palette.primary.main,
        },

        [theme.breakpoints.down('md')]: {
            width: '100%'
        }
    },
}))(InputBase);

export const BootstrapInput = forwardRef((props, ref) => {
    return (
        <TextInput 
            inputRef={ref}
            {...props}
        />
    )
})
